import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Navbar, Card, Form, Button, ButtonGroup } from 'react-bootstrap';

function MemoDetailPage({
  memos,
  editingId,
  editingDraft,
  setEditingDraft,
  handleEdit,
  handleSave,
  handleDelete,
}) {
  const { id } = useParams();
  const navigate = useNavigate();
  const memo = memos.find((m) => m.id === id);
  const isEditing = memo && editingId === memo.id;
  const title = isEditing ? editingDraft.title : (memo?.title ?? '');
  const content = isEditing ? editingDraft.content : (memo?.content ?? '');

  const handleTitleChange = (e) => {
    setEditingDraft((prev) => ({ ...prev, title: e.target.value }));
  };
  const handleContentChange = (e) => {
    setEditingDraft((prev) => ({ ...prev, content: e.target.value }));
  };
  const handleSaveClick = () => {
    handleSave(memo.id, title, content);
  };
  const onDelete = () => {
    handleDelete(memo.id);
    navigate('/');
  };

  if (!memo) {
    return (
      <>
        <Navbar bg="primary" variant="dark" className="shadow-sm">
          <Container>
            <Navbar.Brand className="fw-bold">메모 앱</Navbar.Brand>
            <Button variant="light" size="sm" onClick={() => navigate('/')}>
              목록
            </Button>
          </Container>
        </Navbar>
        <Container className="py-4">
          <p className="text-muted">메모를 찾을 수 없습니다.</p>
          <Button variant="outline-primary" onClick={() => navigate('/')}>
            목록으로
          </Button>
        </Container>
      </>
    );
  }

  const dateStr = new Date(memo.createdAt).toLocaleString('ko-KR');

  return (
    <>
      <Navbar bg="primary" variant="dark" className="shadow-sm">
        <Container>
          <Navbar.Brand className="fw-bold">메모 앱</Navbar.Brand>
          <Button variant="light" size="sm" onClick={() => navigate('/')}>
            목록
          </Button>
        </Container>
      </Navbar>

      <Container className="py-4">
        <Card className="shadow-sm">
          <Card.Body>
            {isEditing ? (
              <>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="제목"
                    value={title}
                    onChange={handleTitleChange}
                    className="fs-5 fw-semibold"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    placeholder="내용"
                    value={content}
                    onChange={handleContentChange}
                    rows={12}
                    className="border"
                  />
                </Form.Group>
                <ButtonGroup>
                  <Button variant="success" onClick={handleSaveClick}>
                    저장
                  </Button>
                  <Button variant="outline-danger" onClick={onDelete}>
                    삭제
                  </Button>
                  <Button variant="outline-secondary" onClick={() => navigate('/')}>
                    목록
                  </Button>
                </ButtonGroup>
              </>
            ) : (
              <>
                <Card.Title className="mb-2">{memo.title || '(제목 없음)'}</Card.Title>
                <Card.Text
                  as="div"
                  className="text-muted mb-2 memo-content memo-content--scroll-20"
                >
                  {memo.content || '(내용 없음)'}
                </Card.Text>
                <Card.Text as="small" className="text-body-secondary d-block mb-3">
                  {dateStr}
                </Card.Text>
                <ButtonGroup>
                  <Button variant="outline-primary" onClick={() => handleEdit(memo.id)}>
                    수정
                  </Button>
                  <Button variant="outline-danger" onClick={onDelete}>
                    삭제
                  </Button>
                  <Button variant="outline-secondary" onClick={() => navigate('/')}>
                    목록
                  </Button>
                </ButtonGroup>
              </>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}

export default MemoDetailPage;
